import _ from 'lodash';
import PropTypes from 'prop-types';
import semver from 'semver';

import SharedConfig from 'shared/config';

export const inputInfoShape = {
  source: PropTypes.string,
  version: PropTypes.sttring,
  minVersion: PropTypes.string,
  validVersion: PropTypes.bool,
  versionError: PropTypes.string,
};

export const inputInfo = text => {
  if (text) {
    const simcMinVersion = SharedConfig.addon.simc.minVersion;

    const lines = _.split(text, '\n');

    // check simc addon version
    const simcVersionLine = _.find(lines, l => l.match(/# SimC Addon/));
    const simPermutProfileLine = _.find(lines, l => l.match(/^\[Profile\]/));

    if (simcVersionLine) {
      let version;
      let validVersion = true;
      let minVersionDiff;
      let versionError;

      const matches = simcVersionLine.match(/^# SimC Addon (.*)$/);
      if (matches) {
        // THIS DROPS ALPHA/BETA/BUILD TAGS
        // This is intentional as the semver library explicitly does not allow prerelease comparisons across
        // major/minor/patch boundaries. For SimC addon, I just want to know about major/minor/patch
        const versionString = matches[1];
        version = semver.coerce(versionString);
        if (semver.valid(version)) {
          try {
            version = semver.coerce(versionString);

            validVersion = semver.satisfies(version, `>= ${simcMinVersion}`);
            minVersionDiff = semver.diff(version, simcMinVersion);
            if (!validVersion && _.includes(['premajor', 'preminor', 'prerelease'], minVersionDiff)) {
              validVersion = true;
            }
          } catch (error) {
            versionError = error.message;
            validVersion = false;
          }

          const result = {
            source: 'simc-addon',
            version: _.get(version, 'version'),
            versionRaw: versionString,
            versionDetails: JSON.parse(JSON.stringify(version)), // make into a plain object
            minVersion: simcMinVersion,
            minVersionDiff,
            validVersion,
            versionError,
          };
          return result;
        }
      }
    } else if (simPermutProfileLine) {
      return {
        source: 'simpermut',
        version: null,
        validVersion: true,
      };
    }
    return {
      source: 'unknown',
      version: null,
      minVersion: simcMinVersion,
      validVersion: false,
    };
  }
  return null;
};
